import ResetPasswordForm from './ResetPasswordForm';
import { userActions } from '../../redux/actions/userActions';
import { connect } from 'react-redux';

const mapStateToProps = ({
  authentication: { error, email, success },
  form: { ResetPasswordForm }
}) => {
  return {
    initialValues: { source_url: window.location.origin + '/update-password' },
    hasError: error && ResetPasswordForm && ResetPasswordForm.submitSucceeded,
    success,
    email
  };
};

const mapDispatchToProps = dispatch => ({
  onSubmit: ({ email, source_url }) =>
    dispatch(userActions.resetPassword(email, source_url))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/components/resetPassword/ResetPasswordFormContainer.js